import axiosInstance from "../Axois";

// Function to send OTP to the user's email
export const sendOtpToEmail = async (body) => {
  try {
    const response = await axiosInstance.post("customer/auth/login/send-otp", body);
    return response.data;
  } catch (error) {
    return error?.response?.data; // Return error response if there's an issue
  }
};

// Function to verify OTP entered by the user
export const verifyOtpApi = async (body) => {
  try {
    // Assuming verify OTP endpoint is different, e.g., "verify-otp"
    const response = await axiosInstance.post("customer/auth/login/verify-otp", body);
    return response.data;
  } catch (error) {
    return error?.response?.data; // Return error response if there's an issue
  }
};


export const sendOtpToSignUpEmail = async (body) => {
  try {
    // Assuming verify OTP endpoint is different, e.g., "verify-otp"
    const response = await axiosInstance.post("customer/auth/register/send-otp", body);
    return response.data;
  } catch (error) {
    return error?.response?.data; // Return error response if there's an issue
  }
};

export const registerUserSendOtp = async (body) => {
  try {
    // Assuming verify OTP endpoint is different, e.g., "verify-otp"
    const response = await axiosInstance.post("customer/auth/register/verify-otp", body);
    return response.data;
  } catch (error) {
    return error?.response?.data; // Return error response if there's an issue
  }
};

export const googleAuthApi = async (body) => {
  try {
    const response = await axiosInstance.post("customer/auth/google", body);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};